import {regexSlug} from "utils/utils";

export const CATEGORY_VALIDATION = {
    name: {
        required: 'Nama kategori wajib diisi',
    },
    slug: {
        format: {
            pattern: regexSlug,
            message: 'Format slug tidak sesuai (contoh : lip-cream)',
        },
    },
}
